module.exports = __webpack_public_path__ + "img/online-pay.ad9d2f23.png";